import React from 'react';
import { Loading } from 'virtues-bootstrap';

import s from './styles.module.scss';

const PageLoading = () => (
  <div className={s.pageLoading}>
    <Loading variant="primary" />
  </div>
);

export default PageLoading;
